export interface IEmployee {
  id?: string;
  name?: string;
  partyId?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IEmployee> = {
  IsDeleted: false,
};
